var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcResGeofences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_res_geofences",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-5168 -1646.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5176.3,1666l-3.3,6.6h22l-3.3-6.6",
    transform: "translate(0 0.3)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(5177.4 1652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M5189.2,1656.6c0,4.073-6.6,10.725-6.6,10.725s-6.6-6.652-6.6-10.725a6.6,6.6,0,0,1,13.2,0Z",
    transform: "translate(-5176 -1650)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Path-3",
    "data-name": "Path",
    cx: 2.063,
    cy: 2.063,
    r: 2.063,
    transform: "translate(4.537 4.537)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResGeofences);
export default __webpack_public_path__ + "static/media/ic_res_geofences.42d8fb3f8f68b94dde72e000e3bb2d91.svg";
export { ForwardRef as ReactComponent };